export const GET_PATIENT_PROFILE = 'get_patient_profile';
export const RESET_PATIENT_PROFILE = 'reset_patient_profile';
export const GET_PATIENT_ORDERS = 'get_patient_orders';
export const RESET_PATIENT_ORDERS = 'reset_patient_orders';
export const GET_ORDER_ROUTES = 'get_order_routes';
export const SHOW_ORDERS = 'show_orders';
export const PATIENT_PROFILE_RESET = 'patient_profile_reset';
